.pageBlogPage {
  position: absolute;
  height: 100%;
  max-width: 1400px;
  width: calc(100% - 50px);

  @media screen and (max-width: 950px) {
    width: calc(100% - 30px);
  }
}